import { yupResolver } from '@hookform/resolvers/yup'
import { Box, Typography } from '@material-ui/core'
import Container from '@material-ui/core/Container'
import CssBaseline from '@material-ui/core/CssBaseline'
import Link from '@material-ui/core/Link'
import { makeStyles } from '@material-ui/core/styles'
import React, { useState } from 'react'
import { useForm } from 'react-hook-form'
import { useHistory } from 'react-router-dom'
import { Button } from 'src/components/ui/Button'
import { SynRoutes } from 'src/core/consts/synRoutes'
import { solicitarCodigoPrimeiroAcesso } from 'src/api/auth'
import { SolicitarCodigoPrimeiroAcessoQuery } from 'src/types'
import Swal from 'sweetalert2'
import { TextField } from '../../components/ui/TextField'
import yup from '../../components/yupCustom'

const useStyles = makeStyles(theme => ({
  loginContainer: {
    width: '100vw',
    minWidth: '100vw',
    height: '100vh',
    margin: 0,
    background: '#374666',
    padding: 0
  },
  loginBox: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    background: '#fff',
    borderRadius: '8px',
    width: '480px',
    boxSizing: 'border-box',
    padding: '40px',
    margin: '40px auto 0'
  },
  logo: {
    margin: theme.spacing(1),
    width: 80
  },
  submit: {
    margin: theme.spacing(3, 0, 2)
  },
  [theme.breakpoints.down('sm')]: {
    loginBox: {
      borderRadius: '0',
      width: '100%',
      height: '100%',
      padding: '40px',
      margin: 0
    }
  }
}))

const schema = yup.object().shape({
  cpf: yup.string().required().label('CPF'),
  telefone: yup.string().required().label('Telefone')
})

export default function SolicitarPrimeiroAcessoPage() {
  const classes = useStyles()
  const history = useHistory()
  const [loading, setLoading] = useState<boolean>(false)

  const {
    control,
    errors,
    watch,
    handleSubmit
  } = useForm<SolicitarCodigoPrimeiroAcessoQuery>({
    mode: 'all',
    resolver: yupResolver(schema),
    defaultValues: { cpf: '', telefone: '' }
  })

  const command = watch()

  function handleKeyDownEnter(e) {
    if (e.key === 'Enter') {
      handleSubmit(onSubmit)()
    }
  }

  const onSubmit = async (data: SolicitarCodigoPrimeiroAcessoQuery) => {
    const lastRequest = localStorage.getItem('primeiro_acesso_last_request')
    if (lastRequest) {
      const timeDiff = new Date().getTime() - new Date(lastRequest).getTime()
      if (timeDiff < 5 * 60 * 1000) {
        Swal.fire('Atenção', 'Aguarde 5 minutos antes de solicitar um novo código.', 'warning')
        return
      }
    }

    setLoading(true)
    try {
      let payload = { ...data }

      await solicitarCodigoPrimeiroAcesso(payload)

      localStorage.setItem('primeiro_acesso_last_request', new Date().toISOString())
      localStorage.setItem('primeiro_acesso_cpf', data.cpf)

      Swal.fire(
        'Sucesso!',
        'Se os dados estiverem corretos, você receberá o código pelo WhatsApp em breve. Clique no link que chegará no seu WhatsApp para validar.',
        'success'
      )
    } catch (e) {
      const errorMsg = e?.response?.data?.erros?.[0] || e?.response?.data?.mensagem || 'Ocorreu um erro ao solicitar o código'
      Swal.fire('Ops...', errorMsg, 'error')
    } finally {
      setLoading(false)
    }
  }

  return (
    <Container
      component="main"
      maxWidth="xs"
      className={classes.loginContainer + ' fadeInTransition'}
    >
      <CssBaseline />
      <div className={classes.loginBox}>
        <img
          src="/image/logo-vertical.png"
          className={classes.logo}
          alt="logo syn saúde"
        />
        <Typography component="h1" variant="h6" style={{ marginBottom: 16 }}>
          Primeiro Acesso
        </Typography>
        <Typography variant="body2" align="center" style={{ marginBottom: 16 }}>
          Informe seus dados para receber o código de acesso no seu WhatsApp.
        </Typography>
        <form onSubmit={handleSubmit(onSubmit)} style={{ width: '100%' }}>
          <TextField
            mask={'999.999.999-99'}
            control={control}
            value={command.cpf}
            onKeyDown={handleKeyDownEnter}
            erro={errors}
            name="cpf"
            type="tel"
            label="CPF"
          />
          <TextField
            mask={'(99) 99999-9999'}
            control={control}
            value={command.telefone}
            onKeyDown={handleKeyDownEnter}
            erro={errors}
            name="telefone"
            type="tel"
            label="Telefone com DDD"
          />
          <Button
            loading={loading}
            disabled={loading}
            type="submit"
            fullWidth
            variant="contained"
            color="primary"
            className={classes.submit}
          >
            Enviar Código
          </Button>
          <Box textAlign="center">
            <Link
              color="secondary"
              variant="body2"
              onClick={() => history.push(SynRoutes.signin)}
              component="button"
              type="button"
            >
              Voltar para o Login
            </Link>
          </Box>
        </form>
      </div>
    </Container>
  )
}
